import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Headers, Http, RequestOptions} from '@angular/http';
import {Router} from '@angular/router';
import {Constants} from '../../constants';

import { LoadingService } from '@core/services';

import { fadeAnimation } from '../../app.animations';

@Component({
  selector: 'app-email-validation-resend',
  templateUrl: './email-validation-resend.component.html',
  styleUrls: ['./email-validation-resend.component.css'],
  animations: [fadeAnimation]
})
export class EmailValidationResendComponent implements OnInit {

  form: FormGroup;
  hasMessage: boolean = false;
  responseMessage: string = '';

  constructor(
    private _formBuilder: FormBuilder,
    private _http: Http,
    private _router: Router,
    private _loadingService: LoadingService
  ) { }

  ngOnInit() {
    this.form = this._formBuilder.group({
      Email: ['', [Validators.required]]
    });
  }

  onSubmit(form) {
    this._loadingService.showLoader();
    if(!form.valid) return;
    let data = form.value;

    const url = Constants.NEXPRESS_ENDPOINT + 'Account/SendValidation';

    this._http.post(url, data)
      .map(response => response.json())
      .subscribe(
        result => {
          this.responseMessage = result + "! Please check your email for a validation email.";
          this.hasMessage = true;
          this._loadingService.hideLoader();
        },
        error => {
          let body = JSON.parse(error._body) || '';
          this.responseMessage = 'Error! ' + body.Message;
          this.hasMessage = true;
          this._loadingService.hideLoader();
        }
      );

  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/email-validation-resend/email-validation-resend.component.ts